import { Component } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'flowaccount-google-workspace',
  templateUrl: './google-workspace.component.html',
})
export class GoogleWorkspaceComponent {
  public customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL',
  }
  protected langChangeSubscription: Subscription
  constructor(
    private readonly seoService: SEOService,
    private readonly titleService: Title,
    public translate: TranslateService,
  ) {
    this.langChangeSubscription = translate.onLangChange.subscribe((event) => {
      this.setMeta()
    })
  }
  setMeta() {
    const metaTitle = this.translate.instant('metaTitle-google-workspace')
    const metaDescription = this.translate.instant('metaDescription-google-workspace')
    const imageUrl = 'https://flowaccountcdn.com/new_landing/image/google-workspace/og_image.jpg'

    this.titleService.setTitle(metaTitle)
    this.seoService.createMetaTag(metaTitle, metaDescription)
    this.seoService.createOg(imageUrl, metaTitle, metaDescription)
  }
  ngOnDestroy() {
    this.langChangeSubscription?.unsubscribe()
  }
}
